import React from "react";
import { Helmet } from "react-helmet-async";
import { Button, Container } from "../components/ui";

const NotFound = () => (
  <>
    <Helmet>
      <title>Not found — Jephthah Boateng</title>
      <meta name="robots" content="noindex" />
    </Helmet>

    <Container className="flex min-h-[80vh] flex-col items-start justify-center py-40">
      <p className="t-eyebrow">Error 404</p>
      <h1 className="t-display mt-7 max-w-3xl">
        This page was never built.
      </h1>
      <p className="t-lead mt-7 max-w-prose">
        The address is wrong, or something moved during the redesign. Either way,
        the work is still here.
      </p>
      <div className="mt-10 flex flex-wrap gap-4">
        <Button to="/" withArrow>
          Back to the index
        </Button>
        <Button to="/projects" variant="outline" withArrow>
          See the work
        </Button>
      </div>
    </Container>
  </>
);

export default NotFound;
